import { Api, ConfigHelper } from 'relapp-api';

const routes = ConfigHelper.entityApiRoutes('payment');

export default {
    /**
     * Payment checkout url.
     *
     * @return {Promise}
     */
    checkout() {
        const route = routes['checkout-url'];
        const currentUrl = [window.location.protocol, '//', window.location.host, window.location.pathname].join('');

        return Api.get(route, {
            params: {
                redirectUrl: currentUrl + '?' + mollieConfig.redirectQueryParam
            }
        });
    }
};
